import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage as FM } from 'react-intl';

import DateSelector from './_components/DateSelector';

import { staticStyles } from './style';

const InputDate = ({ name, options, onSelect, isDisabled }) => (
  <div className="InputDate">
    <div className="InputDate__Title">
      <FM id={name}>{txt => <span className="InputDate__Title-text">{txt}</span>}</FM>
    </div>
    <DateSelector isDisabled={isDisabled} options={options} onSelect={onSelect} dropDownTitle={name} />
    <style jsx>{staticStyles}</style>
  </div>
);

InputDate.propTypes = {
  options: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

InputDate.defaultProps = {
  isDisabled: false,
};

export default InputDate;
